import { useQuery } from "react-query";
import { SrxApi } from "../api/SrxApi";

const useGetReleaseNotes = (versionId) => {
  const getAllReleaseNotes = async () => {
   const response = await SrxApi.get(`/versions/release-notes/${versionId}`, {
   });
    return response?.data;
  };

  const {
    data: getAllReleaseNote = null,
    isFetching: getAllReleaseNoteLoading,
  } = useQuery(
  ["getAllReleaseNote", versionId],
  getAllReleaseNotes,
  {
      enabled: !!versionId, 
    staleTime: 0,             
    refetchOnWindowFocus: true
  }
);

  return {
    getAllReleaseNote,
    getAllReleaseNoteLoading,
  };
};

export default useGetReleaseNotes;
